import { CanDeactivateFn, RouterStateSnapshot } from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate: (state?: RouterStateSnapshot) => boolean;
}

export const navigationGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component,
  _currentRoute,
  _currentState,
  nextState
) => {
  return component.canDeactivate(nextState);
};
